import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
const PageHeader = /*#__PURE__*/ __WEBPACK_EXTERNAL_MODULE_react__["default"].forwardRef(({ title, subtitle, onBack, open, onClose, className = "", backIcon = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CircleChevronLeft, {
    className: "tw-stroke-1 tw-w-8 tw-h-8 tw-text-neutral-300"
}), children, ...props }, ref)=>{
    if (false === open) return null;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        ref: ref,
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("tw-sticky tw-top-0 tw-z-10 tw-bg-white tw-border-b tw-border-neutral-200 tw-px-4 tw-py-5", className),
        ...props,
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-justify-between",
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                    className: "tw-flex tw-items-center",
                    children: [
                        onBack && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
                            onClick: onBack,
                            className: "tw-mr-3 tw-p-1 tw-rounded-full tw-transition-colors hover:tw-bg-accent hover:tw-text-accent-foreground",
                            "aria-label": "Go back to previous page",
                            children: backIcon
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                            children: [
                                subtitle && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                    className: "tw-text-sm tw-text-neutral-600 tw-mb-0.5",
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("h1", {
                                    className: "tw-text-lg tw-font-medium tw-text-neutral-800",
                                    children: title
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                    className: "tw-flex tw-items-center tw-space-x-2",
                    children: children
                }),
                onClose && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("button", {
                    onClick: ()=>onClose(false),
                    className: "tw-absolute tw-top-2 tw-right-2 tw-p-1 tw-rounded-sm tw-opacity-70 tw-ring-offset-background tw-transition-opacity hover:tw-opacity-100 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2 disabled:tw-pointer-events-none",
                    "aria-label": "Close",
                    children: [
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.X, {
                            className: "tw-h-3 tw-w-3"
                        }),
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
                            className: "tw-sr-only",
                            children: "Close"
                        })
                    ]
                })
            ]
        })
    });
});
PageHeader.displayName = "PageHeader";
export { PageHeader };

//# sourceMappingURL=page-header.mjs.map